import { buildUrl, handleRequest } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';
import { Id, SubmissionStatus } from '@common/types';

const basePath = process.env.REACT_APP_API_PATH;

const buildQuery = (search: string | null, limit?: number) => {
  const query = [];

  search && query.push(`search=${search}`);
  limit && query.push(`limit=${limit}`);

  return query.join('&');
};

const fetchActiveIngredientsSearch = async (search: string) => {
  const url = buildUrl('/substance', basePath, `search=${search ?? ''}`);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchUnitsOfMeasurement = async (search: string | null, limit?: number) => {
  let url = buildUrl(`/substance/unit`, basePath, buildQuery(search, limit));

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchMaNumbersConfig = async () => {
  const url = buildUrl(`/regulated-market`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchProductsTree = async (queryString: string) => {
  const url = buildUrl(`/product/tree`, basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchCompanyProducts = async (companyId: number, queryString: string) => {
  const url = buildUrl(`/product/company/${companyId}`, basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchProductSubmissionStatuses = async (productGroupId: number, submissionStatus: SubmissionStatus) => {
  const url = buildUrl(`/product-group/${productGroupId}/submission`, basePath, `submissionStatus=${submissionStatus}`);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchProductHistory = async (id: string) => {
  const url = buildUrl(`/product/${id}/history`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const retirePublishedProduct = async (productGroupId: Id, productId: Id, dataSet: unknown) => {
  const url = buildUrl(`/product-group/${productGroupId}/product/${productId}/retirement`, basePath);

  return handleRequest({ url, requestType: RequestType.POST, data: dataSet });
};

export {
  fetchMaNumbersConfig,
  fetchProductsTree,
  fetchCompanyProducts,
  fetchProductSubmissionStatuses,
  fetchActiveIngredientsSearch,
  fetchUnitsOfMeasurement,
  fetchProductHistory,
  retirePublishedProduct,
};
